// extracted by mini-css-extract-plugin
export default {"buttonText":"qeWzT"};